export const REQUEST_ADD_ENTITY = 'entity/REQUEST_ADD_ENTITY';
export const REQUEST_FETCH_ENTITY = 'entity/REQUEST_FETCH_ENTITY';
export const REQUEST_UPDATE_ENTITY = 'entity/REQUEST_UPDATE_ENTITY';
export const REQUEST_DELETE_ENTITY = 'entity/REQUEST_DELETE_ENTITY';
export const REQUEST_FULL_ENTITY = 'entity/REQUEST_FULL_ENTITY';
export const REQUEST_UPDATE_ITEMS = 'entity/REQUEST_UPDATE_ITEMS';
export const REQUEST_COPY_ITEMS = 'entity/REQUEST_COPY_ITEMS';
export const REQUEST_DELETE_ITEMS = 'entity/REQUEST_DELETE_ITEMS';
export const REQUEST_ADD_FOLDER = 'entity/REQUEST_ADD_FOLDER';
export const REQUEST_UPDATE_FOLDER = 'entity/REQUEST_UPDATE_FOLDER';
export const REQUEST_MOVE_TO_FOLDER = 'entity/REQUEST_MOVE_TO_FOLDER';
export const REQUEST_DUPLICATE_ENTITY = 'entity/REQUEST_DUPLICATE_ENTITY';
export const REQUEST_SAVE_AS_TEMPLATE = 'entity/REQUEST_SAVE_AS_TEMPLATE';
export const REQUEST_FETCH_RESOURCES = 'entity/REQUEST_FETCH_RESOURCES';
export const REQUEST_ADD_TEMPLATE = 'entity/REQUEST_ADD_TEMPLATE';
